import { Component, OnInit } from '@angular/core';
import { ConstantService } from 'src/app/services/constant/constant.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(
    private readonly constantService: ConstantService
  ) { }

  ngOnInit(): void {
  }

  navigateToHomePage(){
    this.constantService.navigateToHome();
  }
}
